const UNAVAILABLE = "unavailable";
const IDLE = "idle";
const UNINIT = "uninitialized";
const SUCCESS = "success";
const LOADING = "loading";
const FAILED = "failed";
const WARNING = "warning";
const unavailableState = () => ({ status: UNAVAILABLE });
const idleState = () => ({ status: IDLE });
const uninitState = () => ({ status: UNINIT });
const loadingState = () => ({ status: LOADING });
const successState = (result) => ({
  status: SUCCESS,
  result
});
const warningState = (state, error) => {
  return {
    ...state,
    status: WARNING,
    error
  };
};
const failedState = (error) => ({
  status: FAILED,
  error
});
const statusIdle = (state) => state.status === IDLE;
const statusUnavailable = (state) => state.status === UNAVAILABLE;
const statusUninit = (state) => state.status === UNINIT;
const statusLoading = (state) => state.status === LOADING;
const statusSuccess = (state) => state.status === SUCCESS;
const statusWarning = (state) => state.status === WARNING;
const statusFailed = (state) => state.status === FAILED;
export {
  FAILED,
  IDLE,
  LOADING,
  SUCCESS,
  UNAVAILABLE,
  UNINIT,
  WARNING,
  failedState,
  idleState,
  loadingState,
  statusFailed,
  statusIdle,
  statusLoading,
  statusSuccess,
  statusUnavailable,
  statusUninit,
  statusWarning,
  successState,
  unavailableState,
  uninitState,
  warningState
};
//# sourceMappingURL=index.js.map
